import * as Types from './api-client.types';
export * from './api-client.types';

//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export * as HL7SettingsClient from './api-client/HL7SettingsClient';

export * as HL7SettingsQuery from './api-client/HL7SettingsQuery';



export * as HL7OutgoingTemplatesClient from './api-client/HL7OutgoingTemplatesClient';

export * as HL7OutgoingTemplatesQuery from './api-client/HL7OutgoingTemplatesQuery';



export * as HL7TemplateRulesClient from './api-client/HL7TemplateRulesClient';

export * as HL7TemplateRulesQuery from './api-client/HL7TemplateRulesQuery';



export * as HL7OutgoingSettingsClient from './api-client/HL7OutgoingSettingsClient';

export * as HL7OutgoingSettingsQuery from './api-client/HL7OutgoingSettingsQuery';



export * as HL7OutgoingMessageClient from './api-client/HL7OutgoingMessageClient';

export * as HL7OutgoingMessageQuery from './api-client/HL7OutgoingMessageQuery';



export * as HL7MessageClient from './api-client/HL7MessageClient';

export * as HL7MessageQuery from './api-client/HL7MessageQuery';



export * as HL7MappingClient from './api-client/HL7MappingClient';

export * as HL7MappingQuery from './api-client/HL7MappingQuery';



export * as HL7MessageTypeMappingClient from './api-client/HL7MessageTypeMappingClient';

export * as HL7MessageTypeMappingQuery from './api-client/HL7MessageTypeMappingQuery';



export * as HL7IncomingSettingsClient from './api-client/HL7IncomingSettingsClient';

export * as HL7IncomingSettingsQuery from './api-client/HL7IncomingSettingsQuery';



export * as HL7FilterClient from './api-client/HL7FilterClient';

export * as HL7FilterQuery from './api-client/HL7FilterQuery';



export * as GDTSettingsClient from './api-client/GDTSettingsClient';

export * as GDTSettingsQuery from './api-client/GDTSettingsQuery';



export * as GDTOutgoingTemplatesClient from './api-client/GDTOutgoingTemplatesClient';

export * as GDTOutgoingTemplatesQuery from './api-client/GDTOutgoingTemplatesQuery';



export * as GDTTemplateRulesClient from './api-client/GDTTemplateRulesClient';

export * as GDTTemplateRulesQuery from './api-client/GDTTemplateRulesQuery';



export * as GDTOutgoingMessageClient from './api-client/GDTOutgoingMessageClient';

export * as GDTOutgoingMessageQuery from './api-client/GDTOutgoingMessageQuery';



export * as GDTMessageClient from './api-client/GDTMessageClient';

export * as GDTMessageQuery from './api-client/GDTMessageQuery';



export * as GDTMappingClient from './api-client/GDTMappingClient';

export * as GDTMappingQuery from './api-client/GDTMappingQuery';



export * as GDTIncomingMessageClient from './api-client/GDTIncomingMessageClient';

export * as GDTIncomingMessageQuery from './api-client/GDTIncomingMessageQuery';



export * as UserClient from './api-client/UserClient';

export * as UserQuery from './api-client/UserQuery';



export * as PasswordValidationSettingsClient from './api-client/PasswordValidationSettingsClient';

export * as PasswordValidationSettingsQuery from './api-client/PasswordValidationSettingsQuery';



export * as UIConfigurationClient from './api-client/UIConfigurationClient';

export * as UIConfigurationQuery from './api-client/UIConfigurationQuery';



export * as TransportClient from './api-client/TransportClient';

export * as TransportQuery from './api-client/TransportQuery';



export * as TransportMessageClient from './api-client/TransportMessageClient';

export * as TransportMessageQuery from './api-client/TransportMessageQuery';



export * as TransportClientClient from './api-client/TransportClientClient';

export * as TransportClientQuery from './api-client/TransportClientQuery';



export * as TenantClient from './api-client/TenantClient';

export * as TenantQuery from './api-client/TenantQuery';



export * as TenantSettingsClient from './api-client/TenantSettingsClient';

export * as TenantSettingsQuery from './api-client/TenantSettingsQuery';



export * as SecuritySettingsClient from './api-client/SecuritySettingsClient';

export * as SecuritySettingsQuery from './api-client/SecuritySettingsQuery';



export * as MeasurementImportSettingsClient from './api-client/MeasurementImportSettingsClient';

export * as MeasurementImportSettingsQuery from './api-client/MeasurementImportSettingsQuery';



export * as GeneralSettingsClient from './api-client/GeneralSettingsClient';

export * as GeneralSettingsQuery from './api-client/GeneralSettingsQuery';



export * as CalendarSettingsClient from './api-client/CalendarSettingsClient';

export * as CalendarSettingsQuery from './api-client/CalendarSettingsQuery';



export * as StatisticsViewerClient from './api-client/StatisticsViewerClient';

export * as StatisticsViewerQuery from './api-client/StatisticsViewerQuery';



export * as RoleClient from './api-client/RoleClient';

export * as RoleQuery from './api-client/RoleQuery';



export * as ResourceClient from './api-client/ResourceClient';

export * as ResourceQuery from './api-client/ResourceQuery';



export * as PatientClient from './api-client/PatientClient';

export * as PatientQuery from './api-client/PatientQuery';



export * as PatientDuplicateClient from './api-client/PatientDuplicateClient';

export * as PatientDuplicateQuery from './api-client/PatientDuplicateQuery';



export * as PatientCommentClient from './api-client/PatientCommentClient';

export * as PatientCommentQuery from './api-client/PatientCommentQuery';



export * as PatientCardHashClient from './api-client/PatientCardHashClient';

export * as PatientCardHashQuery from './api-client/PatientCardHashQuery';



export * as PatientListConfigurationClient from './api-client/PatientListConfigurationClient';

export * as PatientListConfigurationQuery from './api-client/PatientListConfigurationQuery';



export * as NoteClient from './api-client/NoteClient';

export * as NoteQuery from './api-client/NoteQuery';



export * as MeasurementMappingClient from './api-client/MeasurementMappingClient';

export * as MeasurementMappingQuery from './api-client/MeasurementMappingQuery';



export * as DocumentMailSettingsClient from './api-client/DocumentMailSettingsClient';

export * as DocumentMailSettingsQuery from './api-client/DocumentMailSettingsQuery';



export * as SmtpSettingsClient from './api-client/SmtpSettingsClient';

export * as SmtpSettingsQuery from './api-client/SmtpSettingsQuery';



export * as VisitMailServiceSettingsClient from './api-client/VisitMailServiceSettingsClient';

export * as VisitMailServiceSettingsQuery from './api-client/VisitMailServiceSettingsQuery';



export * as LogsClient from './api-client/LogsClient';

export * as LogsQuery from './api-client/LogsQuery';



export * as InputTemplateClient from './api-client/InputTemplateClient';

export * as InputTemplateQuery from './api-client/InputTemplateQuery';



export * as FileClient from './api-client/FileClient';

export * as FileQuery from './api-client/FileQuery';



export * as DocumentClient from './api-client/DocumentClient';

export * as DocumentQuery from './api-client/DocumentQuery';



export * as DocumentTemplateClient from './api-client/DocumentTemplateClient';

export * as DocumentTemplateQuery from './api-client/DocumentTemplateQuery';



export * as DocumentTemplateRuleClient from './api-client/DocumentTemplateRuleClient';

export * as DocumentTemplateRuleQuery from './api-client/DocumentTemplateRuleQuery';



export * as MergeFieldClient from './api-client/MergeFieldClient';

export * as MergeFieldQuery from './api-client/MergeFieldQuery';



export * as MergeFieldPrefixClient from './api-client/MergeFieldPrefixClient';

export * as MergeFieldPrefixQuery from './api-client/MergeFieldPrefixQuery';



export * as DoctorClient from './api-client/DoctorClient';

export * as DoctorQuery from './api-client/DoctorQuery';



export * as VisitTypeClient from './api-client/VisitTypeClient';

export * as VisitTypeQuery from './api-client/VisitTypeQuery';



export * as TagClient from './api-client/TagClient';

export * as TagQuery from './api-client/TagQuery';



export * as FakeOptionalSubtenantDictionaryClient from './api-client/FakeOptionalSubtenantDictionaryClient';

export * as FakeOptionalSubtenantDictionaryQuery from './api-client/FakeOptionalSubtenantDictionaryQuery';



export * as DataBlockClient from './api-client/DataBlockClient';

export * as DataBlockQuery from './api-client/DataBlockQuery';



export * as DataBlockTypeClient from './api-client/DataBlockTypeClient';

export * as DataBlockTypeQuery from './api-client/DataBlockTypeQuery';



export * as DataBlockFieldClient from './api-client/DataBlockFieldClient';

export * as DataBlockFieldQuery from './api-client/DataBlockFieldQuery';



export * as DataBlockDictionaryItemClient from './api-client/DataBlockDictionaryItemClient';

export * as DataBlockDictionaryItemQuery from './api-client/DataBlockDictionaryItemQuery';



export * as DataBlockDictionaryClient from './api-client/DataBlockDictionaryClient';

export * as DataBlockDictionaryQuery from './api-client/DataBlockDictionaryQuery';



export * as CaseClient from './api-client/CaseClient';

export * as CaseQuery from './api-client/CaseQuery';



export * as CalendarConfigurationClient from './api-client/CalendarConfigurationClient';

export * as CalendarConfigurationQuery from './api-client/CalendarConfigurationQuery';



export * as AuditClient from './api-client/AuditClient';

export * as AuditQuery from './api-client/AuditQuery';



export * as AppointmentEventsClient from './api-client/AppointmentEventsClient';

export * as AppointmentEventsQuery from './api-client/AppointmentEventsQuery';



export * as VisitCardSettingsClient from './api-client/VisitCardSettingsClient';

export * as VisitCardSettingsQuery from './api-client/VisitCardSettingsQuery';



export * as AppointmentColorSettingsClient from './api-client/AppointmentColorSettingsClient';

export * as AppointmentColorSettingsQuery from './api-client/AppointmentColorSettingsQuery';



export * as CertificateClient from './api-client/CertificateClient';

export * as CertificateQuery from './api-client/CertificateQuery';



export * as TestApiClient from './api-client/TestApiClient';

export * as TestApiQuery from './api-client/TestApiQuery';



export * as VersionClient from './api-client/VersionClient';

export * as VersionQuery from './api-client/VersionQuery';





import { addResultTypeFactory } from './api-client/helpers';
export { setBaseUrl, getBaseUrl } from './api-client/helpers';
export { setAxiosFactory, getAxios } from './api-client/helpers';


//-----PersistorHydrator.File-----
import type { PersistedClient } from '@tanstack/react-query-persist-client';
import type { DehydratedState, QueryKey } from '@tanstack/react-query'
import { getResultTypeFactory } from './api-client/helpers';

/*
 * If you have Dates in QueryKeys (i.e. in request parameters), you need to deserialize them to Dates correctly
 * (otherwise they are deserialized as strings by default, and your queries are broken).
 */
export function deserializeDate(str: unknown) {
  if (!str || typeof str !== 'string') return str;
  if (!/^\d\d\d\d\-\d\d\-\d\d/.test(str)) return str;
  
  const date = new Date(str);
  const isDate = date instanceof Date && !isNaN(date as any);
  
  return isDate ? date : str;
}

export function deserializeDatesInQueryKeys(queryKey: QueryKey) {
  return queryKey
    // We need to replace `null` with `undefined` in query key, because
    // `undefined` is serialized as `null`.
    // And most probably if we have `null` in QueryKey it actually means `undefined`.
    // We can't keep nulls, because they have a different meaning, and e.g. boolean parameters are not allowed to be null.
    .map(x => (x === null ? undefined : x))
    .map(x => deserializeDate(x));
}

export function deserializeClassesInQueryData(queryKey: QueryKey, data: any) {
  if (!data) {
    return data;
  } else if (typeof data !== 'object') {
    return data;
  } else if ('pages' in data && 'pageParams' in data && Array.isArray(data.pages) && Array.isArray(data.pageParams)) {
    // infinite query
    data.pages = data.pages.map((page:any) => deserializeClassesInQueryData(queryKey, page));
  } else if (Array.isArray(data)) {
    return data.map(elem => constructDtoClass(queryKey, elem));
  } else {
    return constructDtoClass(queryKey, data);
  }
}

/*
 * Pass this function as `deserialize` option to createSyncStoragePersister/createAsyncStoragePersister
 * to correctly deserialize your DTOs (including Dates)
 */
export function persisterDeserialize(cache: string): PersistedClient {
  const client: PersistedClient = JSON.parse(cache);
  client.clientState.queries.forEach((query) => {
    query.state.data = deserializeClassesInQueryData(query.queryKey, query.state.data);
    query.queryKey = deserializeDatesInQueryKeys(query.queryKey);
  });

  return client;
}

export function constructDtoClass(queryKey: QueryKey, data: any): unknown {
  const resultTypeKey = getResultTypeClassKey(queryKey);
  const constructorFunction = getResultTypeFactory(resultTypeKey);

  if (!data || !constructorFunction)
    return data;

  return constructorFunction(data);
}

export function getResultTypeClassKey(queryKey: QueryKey): string {
  if (!Array.isArray(queryKey)) {
    return queryKey as unknown as string;
  }
  if (queryKey.length >= 2) {
    // We concatenate first and second elements, because they uniquely identify the query.
    // All other QueryKey elements are query parameters
    return `${queryKey[0]}___${queryKey[1]}`;
  }

  // We actually should never reach this point :)
  return queryKey.join('___');
}

export function initPersister() {
  
  addResultTypeFactory('HL7SettingsClient___get', (data: any) => Types.initHL7SettingsDto(data));


  addResultTypeFactory('HL7OutgoingTemplatesClient___get', (data: any) => Types.initTemplateListDto(data));
  addResultTypeFactory('HL7OutgoingTemplatesClient___getSingle', (data: any) => Types.initTemplateDto(data));


  addResultTypeFactory('HL7TemplateRulesClient___get', (data: any) => Types.initHL7TemplateRuleDto(data));
  addResultTypeFactory('HL7TemplateRulesClient___getSingle', (data: any) => Types.initHL7TemplateRuleDto(data));


  addResultTypeFactory('HL7OutgoingSettingsClient___get', (data: any) => Types.initHL7OutgoingSettingsDto(data));




  addResultTypeFactory('HL7MessageClient___getMessages', (data: any) => Types.initPageableListDtoOfHL7MessageDto(data));


  addResultTypeFactory('HL7MappingClient___getFields', (data: any) => Types.initMappingFieldDto(data));
  addResultTypeFactory('HL7MappingClient___getAll', (data: any) => Types.initHL7MappingListDto(data));
  addResultTypeFactory('HL7MappingClient___getSingle', (data: any) => Types.initHL7MappingDto(data));


  addResultTypeFactory('HL7MessageTypeMappingClient___getAll', (data: any) => Types.initHL7MessageTypeMappingDto(data));
  addResultTypeFactory('HL7MessageTypeMappingClient___getSingle', (data: any) => Types.initHL7MessageTypeMappingDto(data));


  addResultTypeFactory('HL7IncomingSettingsClient___get', (data: any) => Types.initHL7IncomingSettingsDto(data));


  addResultTypeFactory('HL7FilterClient___getAll', (data: any) => Types.initHL7FilterDto(data));
  addResultTypeFactory('HL7FilterClient___getSingle', (data: any) => Types.initHL7FilterDto(data));


  addResultTypeFactory('GDTSettingsClient___get', (data: any) => Types.initGDTSettingsDto(data));


  addResultTypeFactory('GDTOutgoingTemplatesClient___get', (data: any) => Types.initTemplateListDto(data));
  addResultTypeFactory('GDTOutgoingTemplatesClient___getSingle', (data: any) => Types.initTemplateDto(data));


  addResultTypeFactory('GDTTemplateRulesClient___get', (data: any) => Types.initGDTTemplateRuleDto(data));
  addResultTypeFactory('GDTTemplateRulesClient___getSingle', (data: any) => Types.initGDTTemplateRuleDto(data));


  addResultTypeFactory('GDTOutgoingMessageClient___getNotSentMessages', (data: any) => Types.initPageableListDtoOfGDTMessageDto(data));


  addResultTypeFactory('GDTMessageClient___getMessages', (data: any) => Types.initPageableListDtoOfGDTMessageDto(data));


  addResultTypeFactory('GDTMappingClient___getFields', (data: any) => Types.initMappingFieldDto(data));
  addResultTypeFactory('GDTMappingClient___getAll', (data: any) => Types.initGDTMappingListDto(data));
  addResultTypeFactory('GDTMappingClient___getSingle', (data: any) => Types.initGDTMappingDto(data));




  addResultTypeFactory('UserClient___getUsers', (data: any) => Types.initUserDto(data));
  addResultTypeFactory('UserClient___getUser', (data: any) => Types.initUserDto(data));
  addResultTypeFactory('UserClient___getCurrentUserInfo', (data: any) => Types.initCurrentUserDto(data));


  addResultTypeFactory('PasswordValidationSettingsClient___get', (data: any) => Types.initPasswordValidationSettingsDto(data));


  addResultTypeFactory('UIConfigurationClient___getPatientOverviewConfigurations', (data: any) => Types.initUIConfigurationListDto(data));
  addResultTypeFactory('UIConfigurationClient___getDashboardConfigurations', (data: any) => Types.initUIConfigurationListDto(data));
  addResultTypeFactory('UIConfigurationClient___getConfiguration', (data: any) => Types.initUIConfigurationDto(data));


  addResultTypeFactory('TransportClient___getEnqueuedMessages', (data: any) => Types.initTransportMessageDto(data));




  addResultTypeFactory('TransportClientClient___get', (data: any) => Types.initTransportClientDto(data));


  addResultTypeFactory('TenantClient___getTenant', (data: any) => Types.initTenantDto(data));
  addResultTypeFactory('TenantClient___getSubtenants', (data: any) => Types.initPageableListDtoOfSubtenantDto(data));


  addResultTypeFactory('TenantSettingsClient___get', (data: any) => Types.initTenantSettingsDto(data));


  addResultTypeFactory('SecuritySettingsClient___get', (data: any) => Types.initSecuritySettingsDto(data));


  addResultTypeFactory('MeasurementImportSettingsClient___get', (data: any) => Types.initMeasurementImportSettingsDto(data));


  addResultTypeFactory('GeneralSettingsClient___get', (data: any) => Types.initGeneralSettingsDto(data));


  addResultTypeFactory('CalendarSettingsClient___get', (data: any) => Types.initCalendarSettingsDto(data));


  addResultTypeFactory('StatisticsViewerClient___getReports', (data: any) => Types.initPageableListDtoOfReportListDto(data));


  addResultTypeFactory('RoleClient___getRoles', (data: any) => Types.initRoleDto(data));
  addResultTypeFactory('RoleClient___getRole', (data: any) => Types.initRoleDto(data));


  addResultTypeFactory('ResourceClient___getResource', (data: any) => Types.initResourceDto(data));
  addResultTypeFactory('ResourceClient___getResources', (data: any) => Types.initPageableListDtoOfResourceDto(data));


  addResultTypeFactory('PatientClient___getPatient', (data: any) => Types.initPatientDto(data));
  addResultTypeFactory('PatientClient___getPatients', (data: any) => Types.initPageableListDtoOfPatientListDto(data));


  addResultTypeFactory('PatientDuplicateClient___get', (data: any) => Types.initPageableListDtoOfPatientDuplicatePairDto(data));


  addResultTypeFactory('PatientCommentClient___get', (data: any) => Types.initPatientCommentDto(data));


  addResultTypeFactory('PatientCardHashClient___get', (data: any) => Types.initPatientCardHashDto(data));


  addResultTypeFactory('PatientListConfigurationClient___getPatientListConfiguration', (data: any) => Types.initPatientListConfigurationDto(data));
  addResultTypeFactory('PatientListConfigurationClient___getPatientListConfigurations', (data: any) => Types.initPatientListConfigurationListDto(data));


  addResultTypeFactory('NoteClient___getNote', (data: any) => Types.initNoteDto(data));
  addResultTypeFactory('NoteClient___get', (data: any) => Types.initPageableListDtoOfNoteDto(data));


  addResultTypeFactory('MeasurementMappingClient___get', (data: any) => Types.initMeasurementMappingDto(data));


  addResultTypeFactory('DocumentMailSettingsClient___getDocumentMailSettings', (data: any) => Types.initDocumentMailSettingsDto(data));


  addResultTypeFactory('SmtpSettingsClient___getSubtenantSettings', (data: any) => Types.initSmtpSubtenantSettingsDto(data));


  addResultTypeFactory('VisitMailServiceSettingsClient___get', (data: any) => Types.initVisitMailSettingsDto(data));




  addResultTypeFactory('InputTemplateClient___get', (data: any) => Types.initInputTemplateDto(data));
  addResultTypeFactory('InputTemplateClient___getSingle', (data: any) => Types.initInputTemplateDto(data));


  addResultTypeFactory('FileClient___searchFiles', (data: any) => Types.initFileInfoDto(data));
  addResultTypeFactory('FileClient___getVersionHistory', (data: any) => Types.initFileInfoDto(data));
  addResultTypeFactory('FileClient___getFileInfo', (data: any) => Types.initFileInfoDto(data));


  addResultTypeFactory('DocumentClient___getSingle', (data: any) => Types.initTemplateDto(data));


  addResultTypeFactory('DocumentTemplateClient___get', (data: any) => Types.initTemplateListDto(data));
  addResultTypeFactory('DocumentTemplateClient___getSingle', (data: any) => Types.initTemplateDto(data));


  addResultTypeFactory('DocumentTemplateRuleClient___getSingle', (data: any) => Types.initDocumentTemplateRuleDto(data));
  addResultTypeFactory('DocumentTemplateRuleClient___get', (data: any) => Types.initDocumentTemplateRuleListDto(data));


  addResultTypeFactory('MergeFieldClient___get', (data: any) => Types.initMergeFieldDto(data));
  addResultTypeFactory('MergeFieldClient___getSingle', (data: any) => Types.initMergeFieldDto(data));
  addResultTypeFactory('MergeFieldClient___getQueries', (data: any) => Types.initDocumentQueryDto(data));


  addResultTypeFactory('MergeFieldPrefixClient___get', (data: any) => Types.initMergeFieldPrefixSettingsDto(data));


  addResultTypeFactory('DoctorClient___getDoctor', (data: any) => Types.initDoctorDto(data));
  addResultTypeFactory('DoctorClient___getDoctors', (data: any) => Types.initPageableListDtoOfDoctorListDto(data));


  addResultTypeFactory('VisitTypeClient___get', (data: any) => Types.initVisitTypeDto(data));


  addResultTypeFactory('TagClient___get', (data: any) => Types.initDictionaryRecordDto(data));


  addResultTypeFactory('FakeOptionalSubtenantDictionaryClient___get', (data: any) => Types.initOptionalSubtenantDictionaryRecordDto(data));


  addResultTypeFactory('DataBlockClient___get', (data: any) => Types.initPageableListDtoOfDataBlockDto(data));
  addResultTypeFactory('DataBlockClient___getReimportResult', (data: any) => Types.initReimportResultDto(data));
  addResultTypeFactory('DataBlockClient___getWithValues', (data: any) => Types.initPageableListDtoOfDataBlockWithValuesDto(data));
  addResultTypeFactory('DataBlockClient___getDataBlock', (data: any) => Types.initDataBlockWithValuesDto(data));


  addResultTypeFactory('DataBlockTypeClient___get', (data: any) => Types.initDataBlockTypeDto(data));
  addResultTypeFactory('DataBlockTypeClient___getDataBlockTypesForEditing', (data: any) => Types.initDataBlockTypeListDto(data));
  addResultTypeFactory('DataBlockTypeClient___getUIConfigs', (data: any) => Types.initUIConfigDto(data));
  addResultTypeFactory('DataBlockTypeClient___getUIConfigFields', (data: any) => Types.initUIConfigFieldDto(data));


  addResultTypeFactory('DataBlockFieldClient___get', (data: any) => Types.initDataBlockFieldDto(data));
  addResultTypeFactory('DataBlockFieldClient___getById', (data: any) => Types.initDataBlockFieldDto(data));
  addResultTypeFactory('DataBlockFieldClient___getById2', (data: any) => Types.initDataBlockFieldDto(data));
  addResultTypeFactory('DataBlockFieldClient___getDataBlockFieldsForEditing', (data: any) => Types.initDataBlockFieldListDto(data));


  addResultTypeFactory('DataBlockDictionaryItemClient___get', (data: any) => Types.initPageableListDtoOfDataBlockDictionaryItemDto(data));


  addResultTypeFactory('DataBlockDictionaryClient___get', (data: any) => Types.initDataBlockDictionaryDto(data));


  addResultTypeFactory('CaseClient___getCases', (data: any) => Types.initPageableListDtoOfCaseListDto(data));
  addResultTypeFactory('CaseClient___getCase', (data: any) => Types.initCaseDto(data));


  addResultTypeFactory('CalendarConfigurationClient___getCalendarConfiguration', (data: any) => Types.initCalendarConfigurationDto(data));
  addResultTypeFactory('CalendarConfigurationClient___getCalendarConfigurations', (data: any) => Types.initCalendarConfigurationListDto(data));


  addResultTypeFactory('AuditClient___getAuditRecords', (data: any) => Types.initPageableListDtoOfAuditRecordDto(data));


  addResultTypeFactory('AppointmentEventsClient___searchVisits', (data: any) => Types.initVisitListDto(data));
  addResultTypeFactory('AppointmentEventsClient___getVisit', (data: any) => Types.initVisitDto(data));
  addResultTypeFactory('AppointmentEventsClient___searchAppointments', (data: any) => Types.initAppointmentEventDto(data));
  addResultTypeFactory('AppointmentEventsClient___searchAppointmentsWithResourceOccupation', (data: any) => Types.initAppointmentResourceOccupationDto(data));
  addResultTypeFactory('AppointmentEventsClient___findFreeTimeSlot', (data: any) => Types.initFindFreeTimeSlotResultDto(data));
  addResultTypeFactory('AppointmentEventsClient___getAbsence', (data: any) => Types.initAbsenceDto(data));


  addResultTypeFactory('VisitCardSettingsClient___get', (data: any) => Types.initVisitCardSettingsDto(data));


  addResultTypeFactory('AppointmentColorSettingsClient___get', (data: any) => Types.initAppointmentColorSettingsDto(data));








}
//-----/PersistorHydrator.File----